function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import IconBase, { SMALL_VIEWBOX } from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PinnedNoteIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M9.65686 14.6066L4.00001 20.2635",
    strokeWidth: "2",
    strokeLinecap: "round",
    stroke: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M5.41419 9.65682C6.97628 8.09473 9.50894 8.09473 11.071 9.65683L14.6066 13.1924C16.1687 14.7545 16.1687 17.2871 14.6066 18.8492L5.41419 9.65682Z",
    strokeWidth: "2",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13.1924 4L20.2635 11.0711",
    strokeWidth: "2",
    strokeLinecap: "round",
    stroke: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M14.6066 5.41418L11.071 8.94972M18.8492 9.65683L15.3137 13.1924",
    strokeWidth: "2",
    strokeLinecap: "square",
    stroke: "currentColor"
  }));
}
export function PinnedNoteIconSmall(props) {
  return ___EmotionJSX(IconBase, _extends({
    size: "small",
    viewBox: SMALL_VIEWBOX
  }, props), ___EmotionJSX("path", {
    d: "M7.24267 10.955L3.00004 15.1976",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    stroke: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M4.06063 7.24259C5.2322 6.07102 7.13169 6.07102 8.30327 7.24259L10.9549 9.89424C12.1265 11.0658 12.1265 12.9653 10.9549 14.1369L4.06063 7.24259Z",
    strokeWidth: "1.5",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M9.89429 3L15.1976 8.3033",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    stroke: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M10.955 4.06061L8.30331 6.71226M14.1369 7.24259L11.4853 9.89424",
    strokeWidth: "1.5",
    strokeLinecap: "square",
    stroke: "currentColor"
  }));
}